var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIconBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#353535",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.118,
    cy: 1.882,
    r: 1.882
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.529,
    cy: 7.529,
    r: 1.882
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.118,
    cy: 14.118,
    r: 1.882
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13.647h3.765M11.798 13.647H.437M16.376 2.353h3.012M.437 2.353h11.361M4.314 8H.392M9.412 8h10.353",
    strokeLinecap: "square"
  }))));
}
export default SvgFilterIconBlack;